import classNames from 'classnames';
import { FunctionComponent, h } from 'preact';
import { useRef, useState } from 'preact/hooks';
import { useAccordionAttrs } from '../../hooks/useAccordionAttrs';

export const ShowMoreView: FunctionComponent<{
  labelToOpen?: string;
  labelToClose?: string;
}> = ({ labelToOpen, labelToClose, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);

  const contentAttrs = useAccordionAttrs(contentRef, { isOpen });

  const label = isOpen ? labelToClose ?? 'たたむ' : labelToOpen ?? 'もっと見る';

  return (
    <div className='showmore'>
      <button
        className={classNames('showmore_button', {
          toClose: isOpen,
        })}
        onClick={() => setIsOpen((x) => !x)}
      >
        {label}
      </button>
      <div className='showmore_window' {...contentAttrs}>
        <div className='showmore_content' ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
